/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'redo': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M93.75 50c0 .828-.328 1.625-.914 2.21a3.128 3.128 0 01-2.211.915h-12.5a3.124 3.124 0 110-6.25h3.125a34.37 34.37 0 00-36.269-31.188 34.37 34.37 0 00-32.324 35.262 34.367 34.367 0 0010.34 23.641 34.368 34.368 0 0023.879 9.785 3.124 3.124 0 110 6.25 40.628 40.628 0 01-29.65-68.269A40.633 40.633 0 0144.95 9.426 40.627 40.627 0 0187.5 46.875h3.125c.828 0 1.625.328 2.21.914.586.586.914 1.383.914 2.211z"/>'
  }
})
